import "../../index31.css";
import { jsxs as x, jsx as e } from "react/jsx-runtime";
import { a as C } from "../../core-DVmjA3_O.js";
import { _ as l } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import L from "../Description/index.js";
import A from "../InlineLayout/index.js";
import I from "../InputError/index.js";
import N from "../InputLabel/index.js";
import q from "../Label/index.js";
import D from "../ListView/index.js";
import T from "../../hooks/useSpacingToken.js";
const U = "_input-container_1bo86_1", j = "_input-section_1bo86_4", B = "_general-variant_1bo86_11", P = "_disabled_1bo86_18", z = "_with-update-highlight_1bo86_26", E = "_form-variant_1bo86_27", M = "_transparent-variant_1bo86_28", F = "_with-add-highlight_1bo86_36", G = "_with-remove-highlight_1bo86_46", J = "_errored_1bo86_61", K = "_read-only_1bo86_67", t = {
  inputContainer: U,
  inputSection: j,
  generalVariant: B,
  disabled: P,
  withUpdateHighlight: z,
  formVariant: E,
  transparentVariant: M,
  withAddHighlight: F,
  withRemoveHighlight: G,
  errored: J,
  readOnly: K
};
function ot(p) {
  const {
    containerRef: g,
    inputSectionRef: c,
    actions: m,
    className: _,
    disabled: a,
    error: i,
    errorOnTooltip: o = !1,
    hint: d,
    icons: f,
    input: u,
    label: b,
    readOnly: w,
    required: v,
    variant: r = "form",
    withAsterisk: V,
    spacing: s,
    prevValue: h,
    withPrevValue: y,
    highlightMode: n,
    withPadding: H,
    withBackground: R,
    withDarkBackground: O
  } = p, k = V ?? v, S = T({
    spacing: s,
    offset: r === "transparent" ? -2 : -3,
    modes: ["padding-inline"]
  });
  return /* @__PURE__ */ x(
    D,
    {
      elementRef: g,
      layout: "block",
      className: l(
        t.inputContainer,
        !!i && t.errored,
        w && t.readOnly,
        r === "form" && t.formVariant,
        r === "general" && t.generalVariant,
        r === "transparent" && t.transparentVariant,
        a && t.disabled,
        n === "add" && t.withAddHighlight,
        n === "update" && t.withUpdateHighlight,
        n === "remove" && t.withRemoveHighlight,
        _
      ),
      title: o && i && typeof i == "string" ? i : void 0,
      spacing: s,
      spacingOffset: -4,
      withBackground: R,
      withDarkBackground: O,
      withPadding: H,
      children: [
        /* @__PURE__ */ e(
          N,
          {
            disabled: a,
            required: k,
            children: b
          }
        ),
        /* @__PURE__ */ e(
          A,
          {
            className: l(
              t.inputSection,
              S
            ),
            elementRef: c,
            before: f,
            after: m,
            spacingOffset: -3,
            spacing: s,
            children: u
          }
        ),
        y && h && C(n) && /* @__PURE__ */ e(q, { strong: !0, children: h }),
        !i && !o && d && /* @__PURE__ */ e(
          L,
          {
            withLightText: !0,
            textSize: "sm",
            children: d
          }
        ),
        i && /* @__PURE__ */ e(
          I,
          {
            disabled: a,
            floating: o,
            children: i
          }
        )
      ]
    }
  );
}
export {
  ot as default
};
